// extracted by mini-css-extract-plugin
export default {"hideYearNavigation":"bringg-desktop-calendar_hideYearNavigation__LxHRc","baseCalendar":"bringg-desktop-calendar_baseCalendar__SS69f"};